<template>
  <b-tab title="Faturamento" :active="isTheCurrentTab" @click="() => store.currentTab = 4"
    :disabled="!isTheCurrentTab && !store.isUpdate">
    <b-row>
      <b-col sm="6">
        <b-row>
          <b-col>
            <b-form-group label="Valor R$" label-for="valorPagamento">
              <money class="form-control" id="valorPagamento" name="valorPagamento" :value="valorPagoARealizar"
                @input="onInputValue" v-bind="configMask"
                :disabled="isDevolution && store.formFaturamento.pagamentos.length === 0"
                :class="{ hasErrorsValor: valorError, inputFilledvalor: valorFilled }">
              </money>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Forma de Pagamento" label-for="forma_pagamento">
              <VueSelect ref="buscar_forma_pagamento" :filterable="false" :options="formas_pagamento"
                :disabled="valorPagoARealizar === 0 || isDevolution" @search="onSearchFormaPagamentos"
                @input="setFormaPagamento" v-model="formaPagamento"
                :class="{ hasErrors: pagamentoError, inputFilled: pagamentoFilled }">
                <template slot="no-options">
                  Seleciona a forma de pagamento
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.descricao }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.descricao }}
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <TableApp item="pagamento" subTitulo="" :data="pagamento" :fields="fields" classFilterColumn="valor"
              ref="valor" v-if="formaPagamento !== null && formaPagamento?.descricao !== 'Nenhum'">
              <template slot="customRow" scope="props">
                <span slot="nome" class="pl-0 pt-8" v-if="props.field == 'id'">
                  <div class="d-flex align-items-center">
                    <div class="font-weight-bold text-muted">
                      {{ props.rowData.originalIndex + 1 }}
                    </div>
                  </div>
                </span>
                <span slot="nome" class="pl-0 pt-8" v-if="props.field == 'valor'">
                  <div class="d-flex align-items-center">
                    <div v-b-modal.modal-pagamento @click="changePagamento(props.rowData.originalIndex)"
                      class="font-weight-bold text-muted cursor-pointer">
                      {{ numberToReal(props.rowData.valor, 2) }}
                    </div>
                  </div>
                </span>
                <span slot="quantidade" class="pl-0 pt-8" v-if="props.field == 'vencimento'">
                  <div class="d-flex align-items-center">
                    <div v-b-modal.modal-calendar class="font-weight-bold text-muted cursor-pointer"
                      @click="selectVencimento(props.rowData.originalIndex)">
                      {{ props.rowData.vencimento | moment("DD/MM/YYYY") }}
                    </div>
                  </div>
                </span>
              </template>
            </TableApp>
          </b-col>
        </b-row>
        <b-row>
          <button ref="submit_novo_pagamento123" class="btn btn-primary font-weight-bold ml-10" @click="addPagamento"
            :disabled="isAllInputsNotFull">
            + Adicionar Pagamento
          </button>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-group label="Plano de Contas" label-for="plano_contas">
              <VueSelect ref="buscar_planos" :filterable="false" placeholder="Seleciona um plano de contas"
                :class="{ hasErrors: planoContasError, inputFilled: planoContasFilled }"
                :state="validateFaturamentoState('plano_contas')" :options="plano_contas" v-model="planoConta">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.descricao }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.descricao }}
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <Quest :size="16" />
          <b-col>
            <b-form-group label="Informações Adicionais" label-for="informacoesAdicionais"
              v-b-tooltip="'Para quebrar a linha na impressão utilize ; ao final da frase'">
              <v-textarea full-width rows="6" v-model="form.informacoes_adicionais"></v-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="d-flex flex-row-reverse px-10">
          <div class="d-flex flex-column text-sm-right">
            <span class="font-size-lg font-weight-bolder mb-1">A PAGAR</span>
            <span class="font-size-h2 font-weight-boldest mb-1" :key="(keyToReRender + 1)">R$ {{
    numberToReal(subtotal, 2)
  }}</span>
            <span class="text-success" :key="keyToReRender">
              Valor Pago: R$ {{ numberToReal(valorPago, 2) }}
            </span>
          </div>
        </b-row>
      </b-col>
    </b-row>
    <TableApp class="mt-10" item="pagamento" titulo="Pagamentos" :data="pagamentosRealizados"
      :fields="fieldsPagamentosRealizados" classFilterColumn="formaPagamento" ref="formaPagamento">
      <template slot="customRow" scope="props">
        <span slot="nome" class="pl-0 pt-8" v-if="props.field == 'forma_pagamento'">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold text-muted">
              {{ props.rowData.forma_pagamento.descricao }}
            </div>
            <span
              v-if="props.rowData.range && props.rowData.range.length > 0"
              v-b-tooltip.hover.right.html="formatVencimentosTooltip(props.rowData)"
              class="ml-2 text-primary cursor-pointer"
              style="display: inline-flex; align-items: center;"
            >
              <InformationOutline :size="16" />
            </span>
          </div>
        </span>
        <span slot="quantidade" class="pl-0 pt-8" v-if="props.field == 'valor'">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold text-muted">
              R$ {{ numberToReal(props.rowData.valor, 2) }}
            </div>
          </div>
        </span>
        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 130px">
              <div class="action-buttons">
                <button @click="removePagamento(props.rowData, props.rowData.originalIndex)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2">
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>
    <b-modal id="modal-calendar" title="Ajustar vencimento" size="sm" centered>
      <div class="mx-auto">
        <b-calendar v-model="vencimentoSelected" locale="pt-BR"></b-calendar>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()">
          Cancelar
        </b-button>
        <b-button variant="primary" @click="salvarVencimento" ref="transmitir_nfe">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-pagamento" title="Ajustar pagamento" size="sm" centered>
      <div class="mx-auto">
        <b-form class="form" @submit.stop.prevent="salvarPagamento">
          <money @input="changePagamentoEdited" class="form-control" id="valorPagamento" name="valorPagamento"
            :value="valorPagamento" v-bind="configMask">
          </money>
        </b-form>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()">
          Cancelar
        </b-button>
        <b-button variant="primary" @click="salvarPagamento" ref="transmitir_nfe">
          Salvar
        </b-button>
      </template>
    </b-modal>
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FaturamentoData, { FaturamentoDataRequired } from "../FaturamentoData";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "../../../../components/Table/Table3.vue"
import { SistemaMixin, ValidacaoMixin, InstallmentsMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { store } from "../../storeNfe";
import moment from "moment";
import Quest from "vue-material-design-icons/AccountQuestion.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";

export default {
  name: "app-nfe-form-faturamentoTab",
  components: {
    VueSelect,
    Money,
    TableApp,
    TrashCanIcon,
    Quest,
    InformationOutline,
  },

  directives: {
    mask
  },
  data() {
    return {
      store,
      form: {},
      vencimento: [],
      configMask: settingMoney,
      categorias: [],
      contas: [],
      vencimentoSelected: null,
      indexVencimento: null,
      pagamento: [],
      pagamentosEditados: [],
      formas_pagamento: [],
      formasPagamentoArray: [],
      plano_contas: [],
      selectedPagamento: 0,
      keyToReRender: 0,
      pagamentosRealizados: [],
      fieldsPagamentosRealizados: [
        {
          label: "",
          field: "forma_pagamento",
          slot: true,
          width: "45%",
          sortable: false
        },
        {
          label: "",
          field: "valor",
          slot: true,
          width: "45%",
          sortable: false
        },
        {
          label: "",
          field: "actions",
          slot: true,
          width: "10%",
          sortable: false
        },
      ],
      fields: [
        {
          label: "",
          field: "id",
          slot: true,
          width: "10%",
          sortable: false
        },
        {
          label: "Valor R$",
          field: "valor",
          slot: true,
          width: "45%",
          sortable: false
        },
        {
          label: "Vencimento",
          field: "vencimento",
          slot: true,
          sortable: false,
          width: "45%"
        },
      ],
      subtotal: 0,
      valorPagoARealizar: 0,
      valorPago: 0,
      formaPagamento: null,
      planoConta: null,
      openChangeVencimentoModal: false,
      informacoesAdicionais: '',
      pagamentoEditado: 0,
      valorError: false,
      valorFilled: false,
      pagamentoError: false,
      pagamentoFilled: false,
      planoContasError: false,
      planoContasFilled: false,
    }
  },
  mixins: [
    validationMixin,
    SistemaMixin,
    ValidacaoMixin,
    InstallmentsMixin,
  ],
  validations: {
    form: FaturamentoDataRequired
  },
  methods: {
    ...mapActions(["setLoading"]),
    // Foca o campo de forma de pagamento para o usuario selecionar
    // sem precisar do mouse. O conteudo do b-tab e o input do vue-select
    // podem nao estar prontos (ou a aba ainda estar ativando) ao trocar de
    // aba, por isso ha retry que so para quando o foco realmente "pega".
    focarFormaPagamento() {
      if (this._formaPgtoFocusTries) {
        clearTimeout(this._formaPgtoFocusTries);
      }
      let tentativas = 0;
      const tentar = () => {
        tentativas++;
        const ref = this.$refs.buscar_forma_pagamento;
        const input = ref && ref.$el ? ref.$el.querySelector("input") : null;
        const pronto = input && !input.disabled && input.offsetParent !== null;
        if (pronto) {
          input.focus();
          // Confirma que o foco realmente foi para o input; se nao, tenta de novo.
          if (document.activeElement === input) return;
        }
        if (tentativas < 20) {
          this._formaPgtoFocusTries = setTimeout(tentar, 50);
        }
      };
      this.$nextTick(tentar);
    },
    async getDataInit() {
      this.form = new FaturamentoData({});
      this.vencimentoSelected = this.thisDate();
      this.formas_pagamento = await this.getFormasPagamentos();
      this.formasPagamentoArray = this.formas_pagamento

    },
    async loadPlanoContas(tipoNFe) {
      let tipoNF = 2;

      if (tipoNFe == 0) {
         tipoNF = 1;
      }

      this.plano_contas = await this.getPlanoContas(tipoNF);
      this.planoConta = await this.plano_contas.find(plano => plano.descricao === "Venda de Produtos");

      if (tipoNF == 1) {
        this.planoConta = await this.plano_contas.find(plano => plano.descricao === "Compra de Materia Prima");
      }
    },
    resetPayment() {
      this.pagamentosRealizados = []
      this.form.pagamentos = []
      this.valorPago = 0
      this.subtotal = this.store.formImpostos.totalNFE
      this.valorPagoARealizar = this.store.formImpostos.totalNFE
    },
    preencherPagamentosImportados(formFaturamento) {
      if (!formFaturamento?.pagamentos?.length) return;
      const pagamentos = formFaturamento.pagamentos;
      // Aplica como se fosse inserção manual: altera o state local diretamente,
      // assim o resetPayment() normal continua funcionando se um produto novo for adicionado.
      this.form.pagamentos = [...pagamentos];
      this.pagamentosRealizados = [...pagamentos];
      this.valorPago = pagamentos.reduce((acc, p) => acc + (p.valor || 0), 0);
      this.subtotal = Math.max(0, (this.store.formImpostos.totalNFE || 0) - this.valorPago);
      this.keyToReRender++;
    },
    // Monta o conteúdo HTML do tooltip do (i) ao lado da forma de pagamento.
    // Mostra cada parcela: número, valor e vencimento (data).
    formatVencimentosTooltip(pagamento) {
      const range = pagamento?.range ?? [];
      if (range.length === 0) return '';
      const linhas = range.map((r, i) => {
        const valor = this.numberToReal(parseFloat(r?.value) || 0, 2);
        const data = r?.date ? moment(r.date).format('DD/MM/YYYY') : '-';
        return `${i + 1}ª: R$ ${valor} • ${data}`;
      });
      return `<div style="text-align:left">${linhas.join('<br>')}</div>`;
    },
    removePagamento(pagamentoDeleted, indexToRemove) {
      this.store.formFaturamento.pagamentos = this.store.formFaturamento.pagamentos.filter((pagamento, index) => index !== indexToRemove);
      this.pagamentosRealizados = this.pagamentosRealizados.filter((pagamento, index) => index !== indexToRemove);
      this.subtotal = this.subtotal + pagamentoDeleted.valor;
      this.valorPago = this.valorPago - pagamentoDeleted.valor
    },
    changePagamento(pagamentoIndex) {
      this.selectedPagamento = pagamentoIndex
    },
    closeModalPagamento() {
      this.openChangePagamentoModal = false;
    },
    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },
    salvarPagamento() {
      this.pagamentoEditado = this.round(this.pagamentoEditado, 2);
      this.pagamento[this.selectedPagamento].valor = this.pagamentoEditado;

      const indexEditPagamento = this.pagamentosEditados.findIndex(pagamento => pagamento?.index === this.selectedPagamento)
      if (indexEditPagamento === -1) {
        this.pagamentosEditados.push({
          index: this.selectedPagamento,
          value: this.pagamentoEditado
        })
      } else {
        this.pagamentosEditados.splice(indexEditPagamento, 1, {
          index: this.selectedPagamento,
          value: this.pagamentoEditado
        })
      };

      const pagamentosEditadosTotal = this.pagamentosEditados.reduce((acc, pagamento) => {
        if (pagamento?.value) return this.round(acc + pagamento.value, 2)
        else return acc
      }, 0)

      const editPagamentoCount = this.pagamentosEditados.length

      const pagamentoRestante = this.round(this.valorPagoARealizar - pagamentosEditadosTotal, 2);

      const valorParcelasRestantes = this.round(pagamentoRestante / (this.pagamento.length - editPagamentoCount), 2);

      this.pagamento = this.pagamento.map((item, index) => {
        const hasInPagamentosEditado = this.pagamentosEditados.find(pagamento => pagamento.index === index)
        return {
          ...item,
          valor: hasInPagamentosEditado ?
            this.round(hasInPagamentosEditado.value, 2)
            :
            index !== this.selectedPagamento ?
              valorParcelasRestantes
              :
              this.pagamentoEditado
        }
      })

      this.$bvModal.hide('modal-pagamento')
    },
    validateFaturamentoState() { },
    onSearchConta(search, loading) {
      if (search.length) {
        loading(true);
        this.searchContas(loading, search, this);
      }
    },
    selectVencimento(index) {
      this.indexVencimento = index
    },
    salvarVencimento() {
      this.pagamento[this.indexVencimento].vencimento = this.vencimentoSelected;
      this.$bvModal.hide('modal-calendar')
    },
    closeModalCalendario() {
      this.openChangeVencimentoModal = false;
    },
    clearInputs() {
      this.formaPagamento = null
      this.informacoesAdicionais = ''
      this.planoConta = this.plano_contas.find(plano => plano.descricao === "Venda de Produtos")
      this.valorPagoARealizar = 0
      this.form.vencimento = this.thisDate()
      this.pagamento = []
      this.pagamentosEditados = [];
    },
    addPagamento() {
      this.form.pagamentos = [...this.form.pagamentos, {
        forma_pagamento: this.formaPagamento,
        informacoes_adicionais: this.informacoesAdicionais,
        plano_conta: this.planoConta,
        valor: this.round(this.valorPagoARealizar, 2),
        vencimento: this.form.vencimento,
        range: this.pagamento.map(parcela => ({
          value: this.round(parcela.valor, 2),
          date: moment(parcela.vencimento).format('YYYY-MM-DD')
        }))
      }]
      this.pagamentosRealizados = this.form.pagamentos
      this.valorPago = this.form.pagamentos.reduce((acc, pagamento) => this.round(acc + pagamento.valor, 2), 0)
      this.subtotal = this.round(this.store.formImpostos.totalNFE - this.valorPago, 2)
      this.clearInputs();
      this.keyToReRender++;
    },
    onSearchCategorias(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCategorias(loading, search, this);
      }
    },
    onSearchFormaPagamentos(search, loading) {
      if (search.length) {
        loading(true);
        this.searchFormaPagamentos(search, loading, this);
      } else {
        this.formas_pagamento = this.formasPagamentoArray
      }
    },
    onInputValue(valor) {
      this.changePagamentoValue(valor, this);
    },
    changePagamentoValue: _.debounce((valor, vm) => {
      vm.valorPagoARealizar = vm.round(valor, 2);
      if (valor === 0) return;
      vm.pagamento = vm.calculateInstallments(vm.forma_pagamento, vm.valorPagoARealizar).map(el => ({
        vencimento: el.date,
        valor: el.value
      }))
      vm.vencimentoSelected = vm.pagamento[0]?.vencimento;
      vm.valorError = false
      vm.valorFilled = true
    }, 1000),

    setFormaPagamento(forma_pagamento) {
      this.pagamento = this.calculateInstallments(forma_pagamento, this.valorPagoARealizar).map(el => ({
        vencimento: el.date,
        valor: el.value
      }))
      this.vencimentoSelected = this.pagamento[0]?.vencimento;
      this.formaPagamento = forma_pagamento
      this.pagamentoError = false
      this.pagamentoFilled = true
      this.pagamentosEditados = [];
      // Apos selecionar a forma de pagamento, move o foco para o botao
      // "Adicionar Pagamento" para que o proximo Enter adicione o pagamento
      // (em vez de reabrir o dropdown do vue-select).
      this.$nextTick(() => {
        const botao = this.$refs.submit_novo_pagamento123;
        if (botao && !botao.disabled) botao.focus();
      });
    },
    searchFormaPagamentos: _.debounce(async (search, loading, vm) => {
      vm.formas_pagamento = vm.formasPagamentoArray.filter(item => item.descricao.includes(search));
      loading(false);
    }, 350),
    searchCategorias: _.debounce(async (search, loading, vm) => {
      vm.plano_contas = vm.plano_contas.filter(item => item.descricao.includes(search))
      loading(false);
    }, 350),
    searchContas: _.debounce(async (search, loading, vm) => {
      vm.form.conta = await vm.getContas(search);
      loading(false);
    }, 350),
  },

  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      this.getDataInit();
      const { paymentModeCollection: pagamentos, observation, id_plano_contas } = this.$route.params.nfeData;
      if (this.$route.params.fromDevolucao) {
        this.store.formFaturamento.pagamentos = pagamentos;
      }
      this.form.pagamentos = pagamentos.map(pagamento => ({
        forma_pagamento: {
          descricao: pagamento.descricao,
          id_meio_pagamento: pagamento.paymentMode.id,
          vezes: pagamento.vezes,
          id: pagamento.id,
        },
        informacoes_adicionais: observation ?? "",
        plano_conta: {
          id: id_plano_contas,
        },
        valor: pagamento.value,
        vencimento: pagamento.range[0].date,
        range: pagamento.range,
      }));
      this.form.informacoes_adicionais = observation ?? "";
      this.pagamentosRealizados = this.form.pagamentos;
      this.valorPago = this.pagamentosRealizados.reduce((acc, pagamento) => this.round(acc + pagamento.valor, 2), 0)
      this.subtotal = this.round(this.store.formImpostos.totalNFE - this.valorPago, 2);
    } else {
      this.getDataInit();
    }
  },
  mounted() {
    // Ao entrar na aba de faturamento, ja foca a forma de pagamento.
    if (this.store.currentTab === 4) {
      this.focarFormaPagamento();
    }
  },
  watch: {
    'store.formCliente': {
      handler() {
        if (!this.store.dataFetched || this.store.formNatureza.cfop === '5929' || this.isDevolution) return;
        this.resetPayment();
      },
      deep: true,
    },
    'store.formProduto': {
      handler() {
        if (!this.store.dataFetched || this.store.formNatureza.cfop === '5929' || this.isDevolution) return;
        this.resetPayment();
      },
      deep: true,
    },
    'store.formNatureza': {
      handler() {
        if (!this.store.dataFetched || this.isDevolution) return;
        this.resetPayment();
      },
      deep: true,
    },
    'store.formImpostos.totalNFE'(newValue) {
      if (this.store.formNatureza.cfop !== '5929' && !this.isDevolution) {
        this.resetPayment();
      }
    },

    'store.formFaturamento.pagamentos'(newValue) {
      this.valorPago = newValue.reduce((acc, pagamento) => this.round(acc + pagamento.valor, 2), 0)
    },
    'store.formFaturamento'(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return
      this.form = newValue;
      this.form.informacoes_adicionais = newValue.informacoes_adicionais ?? '';
      this.pagamentosRealizados = newValue.pagamentos
    },
    'store.formNatureza.finalidade'(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.$route.params.fromDevolucao) {
          return;
        }
        if (this.isDevolution || newValue.descricao == "Ajuste") {
          this.formaPagamento = this.formas_pagamento.find(element => element.descricao === "Nenhum")

          this.form.pagamentos = [{
            forma_pagamento: this.formas_pagamento.find(element => element.descricao === "Nenhum"),
            informacoes_adicionais: '',
            plano_conta: this.planoConta,
            valor: 0,
            vencimento: this.form.vencimento,
            range: [{
              value: 0,
              date: moment().format('YYYY-MM-DD')
            }]
          }]
          this.pagamentosRealizados = this.form.pagamentos;
          this.store.formFaturamento = this.form;
          this.subtotal = 0;
          this.valorPagoARealizar = 0;
        }
      }
    },
    'form.vencimento'(newVencimento, oldVencimento) {
      if (newVencimento !== oldVencimento) {
        if (!this.formaPagamento) return;
        this.pagamento = this.calculateInstallments(this.forma_pagamento, this.valorPagoARealizar).map(el => ({
          vencimento: el.date,
          valor: el.value
        }))
        this.vencimentoSelected = this.pagamento[0]?.vencimento;
      }
    },
    form(newValue) {
      this.store.formFaturamento = newValue
    },
    planoConta(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
      this.planoContasFilled = true;
      this.store.formFaturamento.plano_conta = newValue;
    },
    'store.currentTab'(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 4) {
        this.focarFormaPagamento();
      }
      if (this.isTheCurrentTab && this.plano_contas.length === 0) {
        this.loadPlanoContas(this.store.tpNF);
      }
      if (newValue !== oldValue && newValue === 5 && oldValue < newValue) {
        this.$v.form.$touch();

        if (this.store.formFaturamento.pagamentos.length === 0) {
          if (!this.valorPagoARealizar) {
            this.$toast.error('Necessário incluir o valor')
            this.valorError = true;
          }
          if (!this.formaPagamento) {
            this.pagamentoError = true;
            this.$toast.error("Necessário incluir forma de pagamento");
          }
          if (!this.planoConta) {
            this.$toast.error("Necessário incluir plano de contas");
            this.planoContasError = true;
          }
          this.$toast.error("Necessário incluir pagamento");
          this.store.currentTab = oldValue
          return;
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isDevolution() {
      return store.formNatureza.finalidade?.descricao === 'Devolução de mercadoria'
    },
    isAllInputsNotFull() {
      return (this.valorPagoARealizar === 0 || !this.formaPagamento || !this.planoConta)
    },
    valorPagamento() {
      if (this.pagamento.length === 0) return 0
      else return this.pagamento[this.selectedPagamento].valor
    },
    isTheCurrentTab() {
      return store.currentTab === 4
    }
  }
}

</script>

<style>
.hasErrors .vs__dropdown-toggle {
  border: 2px solid red;
  /* color: #394066; */
}

.hasErrors .vs__clear,
.hasErrors .vs__open-indicator {
  fill: red;
}

.inputFilled .vs__dropdown-toggle {
  border: 2px solid #1BC5BD;
  /* color: #394066; */
}

.inputFilled .vs__clear,
.inputFilled .vs__open-indicator {
  fill: #1BC5BD;
}
</style>
